import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { globalState } from 'store/reducer';

export const Success = () => {
  const vocab = useSelector(globalState.selectors.vocab);
  const navigatorLocale = useSelector(globalState.selectors.navigatorLocale);

  const home = useMemo(
    () => vocab[navigatorLocale].home,
    [vocab, navigatorLocale]
  );

  return (
    <div className="my">
      <h3>{home.thanks1}</h3>
      <p>{home.thanks2}</p>
      <p>{home.thanks3}</p>
      <p>
        <a href="mailto:support@customer-updates.com">
          support@customer-updates.com
        </a>
      </p>
    </div>
  );
};
